export default "__VITE_ASSET__CyieuFQV__"